// Google-first /signup layout. Build flag defaults off.
// CRA inlines REACT_APP_* only for a static member read.
// The layout is client-only, so there is no server mirror.

export const SIGNUP_GOOGLE_FIRST_CLIENT_ENV = "REACT_APP_DOPLE_SIGNUP_GOOGLE_FIRST";
export const SIGNUP_LAYOUT_GOOGLE_FIRST = "google_first";
export const SIGNUP_LAYOUT_CLASSIC = "classic";

const TRUTHY = new Set(["1", "true", "yes", "on"]);

export function parseSignupGoogleFirstFlag(value) {
  if (value === true) return true;
  return TRUTHY.has(String(value ?? "").trim().toLowerCase());
}

export function signupGoogleFirstEnabled() {
  return parseSignupGoogleFirstFlag(process.env.REACT_APP_DOPLE_SIGNUP_GOOGLE_FIRST);
}

export function signupLayoutName() {
  return signupGoogleFirstEnabled() ? SIGNUP_LAYOUT_GOOGLE_FIRST : SIGNUP_LAYOUT_CLASSIC;
}
